import ConversationReadingPaneViewState from '../store/schema/ConversationReadingPaneViewState';
import { FocusedItemArea } from '../store/schema/FocusedItemPart';
import ItemPartViewState from '../store/schema/ItemPartViewState';
import readingPaneStore from '../store/Store';
import { select } from 'satcheljs/lib/legacy';

export interface FocusedItemPartState {
    conversationReadingPaneState: ConversationReadingPaneViewState;
}

export const getFocusedItemPart = select<FocusedItemPartState>({
    conversationReadingPaneState: () => readingPaneStore.conversationReadingPaneViewState,
})(function getFocusedItemPart(state?: FocusedItemPartState): ItemPartViewState {
    return state.conversationReadingPaneState.focusedItemPart
        ? state.conversationReadingPaneState.focusedItemPart.itemPart
        : null;
});

export const getFocusedItemArea = select<FocusedItemPartState>({
    conversationReadingPaneState: () => readingPaneStore.conversationReadingPaneViewState,
})(function getFocusedItemPart(state?: FocusedItemPartState): FocusedItemArea {
    return state.conversationReadingPaneState.focusedItemPart
        ? state.conversationReadingPaneState.focusedItemPart.focusedItemArea
        : null;
});

export const getInitiallySelectedItemPart = select<FocusedItemPartState>({
    conversationReadingPaneState: () => readingPaneStore.conversationReadingPaneViewState,
})(function getInitiallySelectedItemPart(state?: FocusedItemPartState): ItemPartViewState {
    return state.conversationReadingPaneState.initiallySelectedItemPart
        ? state.conversationReadingPaneState.initiallySelectedItemPart.itemPart
        : null;
});

export const isItemPartSelected = select<FocusedItemPartState>({
    conversationReadingPaneState: () => readingPaneStore.conversationReadingPaneViewState,
})(function isItemPartSelected(itemPart: ItemPartViewState, state?: FocusedItemPartState): boolean {
    const selectedItemPart = getFocusedItemPart(state);
    const selectedItemArea = getFocusedItemArea(state);
    return selectedItemPart == itemPart && selectedItemArea == FocusedItemArea.Item;
});
